import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Drawer from './drawer'
import Button from '@mui/material/Button';
import {useNavigate} from "react-router-dom"
const pages = [];
const ResponsiveAppBar = (props) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [openDrawer,setDrawer]=React.useState(false)
  const navigate = useNavigate();
  const handleOpenNavMenu = (event) => {
    setDrawer(true)
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const toggleDrawer = () => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setDrawer(false)
  };

  const onButtonClick=()=>{
    if(props.customer){
      props.buttonClick('/login')
    }else{
      props.buttonClick('/adminlogin')
    }
  }
  return (
    <>
    {openDrawer && <Drawer open={openDrawer} toggleDrawer={toggleDrawer}/>}
    <AppBar position="sticky" style={{ background: '#6a6f8c' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow:1,mr: 20, display: { xs: 'none', md: 'flex' } }}
            color="black"
          >
            <label className="playfair-font" style={{color:'white',fontSize:'25'}}>Steparrow</label>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' ,} }}>
            {pages.map((page) => (
                <a href={page.href}
                  key={page.head}
                  sx={{ my: 2, color: 'black', display: 'block' }}
                  style={{marginLeft:40,color:'black',textDecoration:'none'}}
                >
                  <span className="lato-font">{page.head}</span>
                </a>
              ))}
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none'},
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.head} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page.head}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
            color="black"
          >
            <label className="playfair-font">Steparrow</label>
          </Typography>

          {/*<Box sx={{ flexGrow: 0 }}>
               <Tooltip title={'login'}>
              <Button style={{backgroundColor:'darkgrey',color:'white' }} onClick={onButtonClick}>
                <span className="lato-font">{props.customer?'Customer':'Admin'}</span>
              </Button>
            </Tooltip>
              </Box>*/}
          
          
        </Toolbar>
      </Container>
    </AppBar>
    </>
  )
}
export default ResponsiveAppBar;